export default "__VITE_ASSET__CvTVBHcO__"